import { render, staticRenderFns } from "./therm-v2.vue?vue&type=template&id=ac3963c4&scoped=true"
import script from "./therm-v2.vue?vue&type=script&lang=js"
export * from "./therm-v2.vue?vue&type=script&lang=js"
import style0 from "./therm-v2.vue?vue&type=style&index=0&id=ac3963c4&prod&lang=scss&scoped=true"
import style1 from "./therm-v2.vue?vue&type=style&index=1&id=ac3963c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3963c4",
  null
  
)

export default component.exports